import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Button, Alert } from 'react-bootstrap';
import { FaPlus, FaUser } from 'react-icons/fa';
import CollectorTable from '../../components/collectors/CollectorTable';
import CollectorModal from '../../components/collectors/CollectorModal';
import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../../config';
import Layout from '../../components/layouts/Main';

const CollectorsPage = () => {
  const [collectors, setCollectors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editCollector, setEditCollector] = useState(null);

  useEffect(() => {
    fetchCollectors();
  }, []);

  const fetchCollectors = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${config.API_BASE_URL}/collectors`);
      setCollectors(response.data);
    } catch (error) {
      console.error('Error fetching collectors:', error);
      toast.error('Failed to load collectors');
    } finally {
      setLoading(false);
    }
  };

  const handleAddCollector = () => {
    setEditCollector(null);
    setShowModal(true);
  };

  const handleEditCollector = (collector) => {
    setEditCollector(collector);
    setShowModal(true);
  };

  const handleDeleteCollector = async (collector) => {
    if (!window.confirm(`Are you sure you want to delete collector "${collector.name}"?`)) {
      return;
    }

    try {
      await axios.delete(`${config.API_BASE_URL}/collectors/${collector._id}`);
      toast.success('Collector deleted successfully');
      fetchCollectors();
    } catch (error) {
      console.error('Error deleting collector:', error);
      const errorMessage = error.response?.data?.message || 'Failed to delete collector';
      toast.error(errorMessage);
    }
  };

  const handleViewCollector = (collector) => {
    // Could implement a view modal here if needed
    console.log('View collector:', collector);
  };

  const handleCollectorSaved = () => {
    fetchCollectors();
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditCollector(null);
  };

  return (
    <Layout>
      <Row className="mb-4">
        <Col>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2 className="mb-1">
                <FaUser className="me-2 text-primary" />
                Collector Management
              </h2>
              <p className="text-muted mb-0">Manage sample collectors for QC testing</p>
            </div>
            <Button
              variant="primary"
              onClick={handleAddCollector}
              className="d-flex align-items-center"
            >
              <FaPlus className="me-2" />
              Add Collector
            </Button>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card className="border-0 shadow-sm">
            <Card.Body>
              {loading ? (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2">Loading collectors...</p>
                </div>
              ) : collectors.length === 0 ? (
                <Alert variant="info" className="text-center">
                  <FaUser className="me-2" />
                  No collectors found. Click "Add Collector" to create your first collector.
                </Alert>
              ) : (
                <CollectorTable
                  collectors={collectors}
                  onEdit={handleEditCollector}
                  onDelete={handleDeleteCollector}
                  onView={handleViewCollector}
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <CollectorModal
        show={showModal}
        onHide={handleCloseModal}
        onCollectorSaved={handleCollectorSaved}
        editCollector={editCollector}
      />
    </Layout>
  );
};

export default CollectorsPage;
